export default {
  addQuery(state, payload) {
    let queryA = payload;
    if (this.state.language.currentLanguage === "pt") {
      queryA = queryA.map((p) => {
        return p.map((el) => {
          if (el === "crystal") el = "crystal system";
          return this.state.language.translate[el];
        });
      });
    }

    return (state.queryArray = queryA);
  },
  displayNoMatch(state, payload) {
    return (state.noMatch = payload);
  },
  getAllMinerals(state, payload) {
    return (state.results = payload);
  },
  getFilterError(state, payload) {
    return (state.filterError = payload);
  },
  getFilterOptions(state, payload) {
    return (state.filterOptions = payload);
  },
  getPageTitle(state, payload) {
    return (state.currentTitle = state.title[payload]);
  },
  getMineralNames(state, payload) {
    return (state.mineralNames = payload);
  },
  getQuerySuggestions(state, payload) {
    return (state.querySuggestions = payload);
  },
  getOneMineral(state, payload) {
    return (state.results = payload);
  },
  getOnlyOneMineral(state, payload) {
    return (state.oneMineral = payload);
  },
  getSelectOptions(state, payload) {
    return (state.selectOptions = payload);
  },
  getSelect(state, payload) {
    return (state.results = payload);
  },
  hasMineral(state, payload) {
    return (state.hasMineral = payload);
  },
  getRockMineral(state, payload) {
    return (state.rockMineral = payload);
  },
  getFilterResults(state, payload) {
    return (state.filterResults = payload);
  },
};
